/**
 * @module events/types/input
 */

/**
 * @type {string}
 */
export default 'input'
